import React from 'react';
import _ from 'lodash';

import { IRosterShift } from '../../types';
import { OpenSlotCard } from '../../cards/open-slot-card';
import { ROSTER_TAB } from 'views/bookings-v2/bookings-roster-view/components/roster-common-enums';

interface OpenSlotCardListProps {
  unassignedShifts: IRosterShift[][];
}

export const OpenSlotCardList = ({ unassignedShifts }: OpenSlotCardListProps) => {
  return (
    <>
      {unassignedShifts.map((shiftGroup, rowIdx) =>
        shiftGroup.map((shift, shiftIdx) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <OpenSlotCard shift={shift} key={shiftIdx} rowIndex={rowIdx} tab={ROSTER_TAB.DAILY} />
        )),
      )}
    </>
  );
};
